import React, { useState, useCallback } from "react";
import { Col, Container, Row } from "react-bootstrap";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import InputComponent from "../../../../utils/input/Input";
import { Schema } from "../../../../validators/schema/schema";
import ButtonComponent from "../../../../utils/button/ButtonComponent";
import { Colors } from "../../../../utils/colors/colors";
import { constants } from "../../../../constants/constants";
import { usePaystackPayment } from 'react-paystack';
import { toast } from 'react-toastify';








const PayStackForm = ({
  closeModal
}) => {


  const [config, setConfig] = useState({});
  const {
    CURRENCY,
    PAYSTACK_KEY
  } = constants();




  const initializePayment = usePaystackPayment({
    ...config
  });


  const { primaryColor } = Colors();

  const {
    handleSubmit,
    formState: { errors },
    control,
    register,
  } = useForm({
    resolver: yupResolver(Schema().paystackFormSchema),
    mode: "onBlur",
  });





  const onSubmit = useCallback((data) => {
    // Handle form submission
    // console.log(data);

    setConfig({
      reference: (new Date()).getTime().toString(),
      metadata: {
        firstName: data?.firstName,
        lastName: data?.lastName,
      },
      email: data?.email,
      publicKey: PAYSTACK_KEY,
      amount: data?.amount * 100, // in kobo i.e 1000000k === ₦10000
    });



    const onSuccess = (reference) => {
      toast.success("Donation successfully completed");
      closeModal();
    };

    const onClose = () => {
      toast.error("Your donation was unsuccessful, try again later!");
    }


    initializePayment(onSuccess, onClose);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PAYSTACK_KEY, initializePayment]);





  return (
    <div
      style={{
        marginTop: "-3rem",
      }}
    >
      <DonationHeadingWrapper>

        <HeaderTitle
          style={{
            padding: 0,
            margin: 0,
          }}
        >
          Donate to Eraconneckt
        </HeaderTitle>
      </DonationHeadingWrapper>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Container
          style={{
            margin: "0",
            padding: "0",
            minWidth: "100%",
            marginTop: "20px",
          }}
        >
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col xs={{ span: 12, order: 1 }} md={{ span: 6, order: 1 }}>
              <InputComponent
                label={"First name"}
                placeholder={"Enter your first name"}
                hasLabel={true}
                name={"firstName"}
                errorText={errors?.firstName?.message}
                rest={{ ...register("firstName") }}
                id={"firstName"}
                type={"text"}
                cName={"form-input"}
                style={{
                  width: "100%",
                }}
                control={control}
                defaultValue={""}
              />
            </Col>

            <Col xs={{ span: 12, order: 2 }} md={{ span: 6, order: 2 }}>
              <InputComponent
                label={"Last name"}
                placeholder={"Enter your last name"}
                hasLabel={true}
                name={"lastName"}
                errorText={errors?.lastName?.message}
                rest={{ ...register("lastName") }}
                id={"lastName"}
                type={"text"}
                cName={"form-input"}
                style={{
                  width: "100%",
                }}
                control={control}
                defaultValue={""}
              />
            </Col>
          </Row>

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col >
              <InputComponent
                label={"Email Address"}
                placeholder={"Email"}
                hasLabel={true}
                name={"email"}
                errorText={errors?.email?.message}
                rest={{ ...register("email") }}
                id={"email"}
                type={"email"}
                cName={"form-input"}
                style={{
                  width: "100%",
                }}
                control={control}
                defaultValue={""}
              />
            </Col>
          </Row>

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <InputComponent
                label={`Amount to Donate (${CURRENCY})`}
                placeholder={`Amount to Donate (${CURRENCY})`}
                hasLabel={true}
                name={"amount"}
                errorText={errors?.amount?.message}
                rest={{ ...register("amount") }}
                id={"amount"}
                type={"number"}
                cName={"form-input"}
                control={control}
                defaultValue={""}
              />
            </Col>
          </Row>

          <BtnWrapper>
            <ButtonComponent
              bgColor={primaryColor}
              text={"Pay Now"}
              style={{
                minWidth: "100%",
                margin: "2.125rem auto 1rem auto",
              }}
              click={handleSubmit(onSubmit)}
              isLoading={false}
            />
          </BtnWrapper>
        </Container>
      </form>
    </div>
  );
};

export default PayStackForm;

const DonationHeadingWrapper = styled.div`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const HeaderTitle = styled.h3`
  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 37px;
  color: rgb(235, 129, 69);
`;

const BtnWrapper = styled.div`
  margin-top: 40px;
`;
